import { mutations as types } from "./types";

function comparer(a, b) {
  let dayA = new Date(a.base_created);
  let dayB = new Date(b.base_created);
  if (dayA > dayB) {
    return -1;
  }
  return 1;
}

const mutations = {
  [types.NOTI_UPDATE_STATUS](state, status) {
    state.notiBar.status.loadingNoti = status;
  },
  [types.PINNED_SUCCESS](state, noti) {
    let index = 0;
    for (index = 0; index < state.notiBar.noti.length; index++) {
      if (state.notiBar.noti[index].id == noti.id) {
        break;
      }
    }
    state.notiBar.noti.splice(index, 1);
    noti.state = 2;
    state.notiBar.pinnedNoti.push(noti);
    state.notiBar.pinnedNoti.sort(comparer);
  },
  [types.UNPINNED_SUCCESS](state, noti) {
    let index = 0;
    for (index = 0; index < state.notiBar.pinnedNoti.length; index++) {
      if (state.notiBar.pinnedNoti[index].id == noti.id) {
        break;
      }
    }
    state.notiBar.pinnedNoti.splice(index, 1);
    noti.state = 1;
    state.notiBar.noti.push(noti);
    state.notiBar.noti.sort(comparer);
  },
  [types.LOAD_MORE_NOTI](state, noti_list) {
    for (let i = 0; i < noti_list.length; i++) {
      let noti = noti_list[i];
      let broken = false
      for (let j = 0; j < state.notiBar.noti.length; j++) {
        if (state.notiBar.noti[j] == noti) {
          broken = true;
          break
        }
      }
      if (!broken) {
        state.notiBar.noti.push(noti);
      }
    }
    state.notiBar.noti.sort(comparer);
  },
  [types.TRACK_READ](state, noti) {
    let broken = false
    let i = 0
    if (noti.state <= 2) {
      for (i = 0; i < state.notiBar.noti.length; i++) {
        if (state.notiBar.noti[i].id == noti.id) {
          broken = true;
          break
        }
      }
      if (broken) {
        if (state.notiBar.noti[i].state == 0) {
          state.notiBar.noti[i].state = 1
        }
      }
    } else {
      for (i = 0; i < state.notiBar.pinnedNoti.length; i++) {
        if (state.notiBar.pinnedNoti[i].id == noti.id) {
          broken = true;
          break
        }
      }
      if (broken) {
        if (state.notiBar.pinnedNoti[i].state == 0) {
          state.notiBar.pinnedNoti[i].state = 1
        }
      }
    }

  },
  [types.TRACK_ACTION](state, noti) {
    let broken = false
    let i = 0
    if (noti.state <= 2) {
      for (i = 0; i < state.notiBar.noti.length; i++) {
        if (state.notiBar.noti[i].id == noti.id) {
          broken = true;
          break
        }
      }
      if (broken) {
        if (state.notiBar.noti[i].state == 0) {
          state.notiBar.noti[i].state++
        }
      }
    } else {
      for (i = 0; i < state.notiBar.pinnedNoti.length; i++) {
        if (state.notiBar.pinnedNoti[i].id == noti.id) {
          broken = true;
          break
        }
      }
      if (broken) {
        if (state.notiBar.pinnedNoti[i].state == 0) {
          state.notiBar.pinnedNoti[i].state++
        }
      }
    }
  },
  [types.MARK_ALL_READ](state){
    for (let i = 0; i < state.notiBar.noti.length; i++) {
      if (state.notiBar.noti[i].state == 0) {
        state.notiBar.noti[i].state = 1
      }
    }
    state.notiBar.maxAllReaded = true
  }
};

export default mutations;
